<script setup lang="ts">
// Required by Logo.dev free tier: a visible link to logo.dev where logos are shown.
</script>

<template>
  <p class="text-xs text-gray-400 mt-2">
    <a href="https://logo.dev" target="_blank" rel="noopener" class="hover:underline">
      {{ $t('logoAttribution') }}
    </a>
  </p>
</template>
